import { ChartManager } from "..";
import { removeSimpleCrossManager } from "../stateManagement/management";

/**
 * Classe gerenciadora dos gráficos de cruzamento simples
 */
export class SimpleCrossChartManager extends ChartManager {
  constructor(instance) {
    super(instance);

    this._handleOnInstanceUnmount();
  }

  /**
   * Intercepta o método de ciclo de vida "willComponentUnmount" da instância
   * do gráfico de cruzamentos simples para aplicar a lógica de remoção das instâncias
   * dos gerenciadores de gráfico que não estão mais em uso.
   */
  _handleOnInstanceUnmount() {
    if (this.instance) {
      const contextToRemove = this;
      const onUnmount = (() => {
        removeSimpleCrossManager(contextToRemove);
      }).bind(this.instance);

      this.instance.componentWillUnmount = this.instance.componentWillUnmount || onUnmount;
    }
  }

  /**
   * Recupera o identificador do gráfico de cruzamentos simples, o seu identificador é utilizado para o gerenciador
   * ter conhecimento de qual instância de gráfico ele deve processar mudanças. Esse identificador consiste de dois
   * atributos: o índice da linha correspondente ao gráfico (rowIndex) e o índice da coluna (colIndex), tenha em mente
   * que o card de cruzamentos simples pode renderizar múltiplos gráficos, e aqui identificamos o gráfico através de 
   * qual linha e coluna ele foi instanciado.
   */
  getCoordinates() {
    if (this.instance && this.instance.props) {
      const { rowIndex, colIndex } = this.instance.props;

      return `${rowIndex}_${colIndex}`;
    }
  }
}